import utils from '../../services/utils';
import axiosApi from '../../services/inteceptor';

const API_USER_INFO = `${utils.svcUrl()}connect`;

const initialState = {
  currentSegmentDetails: '',
  currentSegment: '',
  dm_loader: false,
  allUsersDmDetails: [],
  dmCounts: [],
  twitElement: '',
};

const mutations = {
  SET_CURRENT_SEGMENT(state, payload) {
    state.currentSegment = payload || '';
  },
  SET_DM_LIST_LOADER(state, payload) {
    state.dm_loader = payload;
  },
  SET_ALL_USERS_DM(state, payload) {
    state.allUsersDmDetails = payload;
  },
  SET_DM_COUNT(state, payload) {
    state.dmCounts = payload;
  },
  SET_NEXT_DM(state, payload) {
    state.allUsersDmDetails[payload.index].allDms = [...payload.data?.reverse(), ...state.allUsersDmDetails[payload.index].allDms];
  },
  SET_TWEET_ELEMENT_ID(state, payload) {
    console.log(payload, 'payload');
    state.twitElement = payload;
  },
};

/**
 * *** userId = member _id
 * creatorId = creator or admin userId (provided by google)
 */
const actions = {
  fetchMembersDmList: async ({ commit, state }, courseId = state.currentSegment) => {
    try {
      console.log({ courseId });
      commit('SET_DM_LIST_LOADER', true);
      const response = await axiosApi.get(`${API_USER_INFO}/get/dm/list?courseId=${courseId}`);
      commit('SET_DM_LIST_LOADER', false);
      // console.log(response);
      commit('SET_ALL_USERS_DM', response.data.data);
      return response.data;
    } catch (error) {
      commit('SET_DM_LIST_LOADER', false);
      commit('SET_ALL_USERS_DM', []);
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
  },
  fetchMembersDmCount: async ({ commit, state }, courseId = state.currentSegment) => {
    try {
      console.log({ courseId });
      const response = await axiosApi.get(`${API_USER_INFO}/get/dm/counts?courseId=${courseId}`);
      // console.log(response, 'count');
      commit('SET_DM_COUNT', response.data.data);
      return response.data;
    } catch (error) {
      commit('SET_DM_COUNT', []);
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
  },
  fetchOlderDm: async ({ commit }, {
    conversationId, skip = 1, index = 0, limit = 10,
  }) => {
    try {
      const response = await axiosApi.get(`${API_USER_INFO}/get/dm/next?conversationId=${conversationId}&skip=${skip}&limit=${limit}`);
      console.log(response, 'response');
      commit('SET_NEXT_DM', { data: response.data.data, index });
      return response.data;
    } catch (error) {
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
  },
};
export default {
  state: initialState,
  mutations,
  actions,
};
